<template>
  <section id="homeInfo">
    <div class="container">
      <div class="header">
        <h5>{{stateName}}</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" class="infoForm" autocomplete="off">
        <h5>Tell us a bit about yourself</h5>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <div class="titleContainer">
                <input type="radio" id="mr" value="Mr" v-model="title">
                <label for="mr">Mr</label>

                <input type="radio" id="mrs" value="Mrs" v-model="title">
                <label for="mrs">Mrs</label>

                <input type="radio" id="miss" value="Miss" v-model="title">
                <label for="miss">Miss</label>

                <input type="radio" id="ms" value="Ms" v-model="title">
                <label for="ms">Ms</label>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="fName">
                First Name
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="name"
                id="fName"
                class="input"
                type="text"
                required
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="lName">
                Last Name
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="lastName"
                id="lName"
                class="input"
                type="text"
                required
              >
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label>
                Identification
                <span>*</span>
              </label>
              <div class="titleContainer identification">
                <input type="radio" id="saId" value="SA ID" v-model="identification.type">
                <label for="saId">SA ID</label>

                <input type="radio" id="Birthday" value="Birthday" v-model="identification.type">
                <label for="Birthday">Birthday</label>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control" v-if="identification.type == 'SA ID'">
              <label for="idNumber">
                Identification Number
                <span>*</span>
              </label>
              <input
                id="idNumber"
                v-validate="'required|numeric'"
                class="input"
                type="number"
                v-model="identification.content"
                required
              >
            </div>
            <div class="control" v-if="identification.type == 'Birthday'">
              <label for="birthDate">
                Birth Date
                <span>*</span>
              </label>
              <input
                id="birthDate"
                v-validate="'required'"
                class="input"
                type="date"
                v-model="identification.content"
                required
              >
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="fName">
                Mobile Number
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="mobileNumber"
                v-mask="'### ### ####'"
                id="fName"
                class="input"
                type="tel"
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="lName">
                Email Address
                <span>*</span>
              </label>
              <input
                id="lName"
                v-validate="'required|email'"
                class="input"
                type="email"
                required
                v-model="email"
              >
              <small>Used to send you your ShavesPaintBucks™ balance</small>
            </div>
          </div>
        </div>
      </form>
      <div class="actions">
        <button @click="back()" class="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toContactInfo()" class="button is-blue">Continue</button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import { mask } from "vue-the-mask";
import alertify from "alertifyjs";

export default {
  name: "individualinfo",
  directives: { mask },
  components: {
    CancelButton
  },
  data() {
    return {
      stateName: this.$store.state.loyaltyType,
      title: "Mr",
      name: null,
      lastName: null,
      identification: {
        type: "SA ID",
        content: null
      },
      mobileNumber: null,
      email: null,
      phoneValue: 0,
      preventNextIteration: false
    };
  },
  methods: {
    toContactInfo() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$store.commit("STORE_PERSONAL_INFO", {
            loyaltyType: this.stateName,
            title: this.title,
            firstName: this.name,
            lastname: this.lastName,
            identification: this.identification,
            mobileNumber: this.mobileNumber,
            email: this.email
          });
          this.$router.push("/address");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    }
  },
  created() {
    if (this.$store.state.loyaltyType == "personal") {
      this.stateName = "Home Improver";
    } else {
      this.stateName = "Pensioners Home Improver";
    }
  },
  mounted(){
    if(this.$store.state.personal.info.title != undefined) {
      this.title = this.$store.state.personal.info.title
      this.name = this.$store.state.personal.info.firstName
      this.lastName = this.$store.state.personal.info.lastname
      this.identification = this.$store.state.personal.info.identification
      this.mobileNumber = this.$store.state.personal.info.mobileNumber
      this.email = this.$store.state.personal.info.email
      console.log("setting values")
    }
  }
};
</script>